<template>
  <PageTitleComponent ref="pageTitle" />
  <div class="webView">
    <iframe :src="webViewUrl" class="webView__iframe"></iframe>
  </div>
</template>

<script>
import PageTitleComponent from "@/components/PageTitleComponent.vue";
import { mapActions, mapState } from "pinia";
import { useMainStore } from "@/store";

export default {
  name: "VehicleView",
  components: { PageTitleComponent },
  data() {
    return {
      title: "",
      key: 0,
    };
  },
  computed: {
    ...mapState(useMainStore, {
      webViewUrl: (store) => store.webViewUrl,
    }),
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let url = "";
      switch (this.$route.params.type) {
        case "configurator":
          url = localStorage.getItem("aixam-configurator-url") + "&salon&tv";
          break;
        case "about":
          url = "https://www.aixam.com/fr/l-esprit-aixam/savoir-faire";
          break;
        case "jpo":
          url = localStorage.getItem("aixam-jpo-url");
          break;
      }
      this.setWebviewUrl(url);
    },

    ...mapActions(useMainStore, ["setWebviewUrl"]),
  },
};
</script>

<style lang="scss" scoped>
.webView {
  padding: 90px 50px;
  height: 100%;
  width: 100%;
  text-align: center;

  &__iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
